export class Scopes {
  public static readonly PEQ_READ = 'oas:iop:logpn:peq_read';
  public static readonly PEQ_WRITE = 'oas:iop:logpn:peq_write';
  public static readonly MEAL_COMPENSATION_READ = 'oas:iop:logpn:meal_compensation_read';
  public static readonly MEAL_COMPENSATION_WRITE = 'oas:iop:logpn:meal_compensation_write';
  public static readonly TAXIS_READ = 'oas:iop:logpn:taxis_read';
  public static readonly TAXIS_WRITE = 'oas:iop:logpn:taxis_write';
  public static readonly PICKUP_READ = 'oas:iop:logpn:pickup_read';
  public static readonly PICKUP_WRITE = 'oas:iop:logpn:pickup_write';
  public static readonly SHUTTLES_READ = 'oas:iop:logpn:shuttles_read';
  public static readonly SHUTTLES_WRITE = 'oas:iop:logpn:shuttles_write';
  public static readonly PARAMETERS_WRITE = 'oas:iop:logpn:parameters_write';
  public static readonly VOI_READ = 'oas:iop:logpn:voi_read';
  public static readonly VOI_WRITE = 'oas:iop:logpn:voi_write';
  public static readonly VDS_READ = 'oas:iop:logpn:vds_read';
  public static readonly VDS_WRITE = 'oas:iop:logpn:vds_write';
  public static readonly VDC_READ = 'oas:iop:logpn:vdc_read';
  public static readonly VDC_WRITE = 'oas:iop:logpn:vdc_write';
  public static readonly HOTEL_READ = 'oas:iop:logpn:hotel_read';
  public static readonly HOTEL_WRITE = 'oas:iop:logpn:hotel_write';
  public static readonly TREATMENT_REQUEST_WRITE = 'oas:iop:logpn:treatmentrequests_write';
  public static readonly POINTS_WRITE = 'oas:iop:logpn:points_write';
  public static readonly ADMIN_POINTS_WRITE = 'oas:iop:logpn:admin_points_write';
  public static readonly AGENT_PROG_POINTS_WRITE = 'oas:iop:logpn:agent_prog_points_write';
}
